// extracted by mini-css-extract-plugin
export var lg = "_1v-4";
export var md = "_1v-3";
export var sm = "_1v-2";
export var xs = "_1v-1";
export var xxs = "_1v-0";